/**
 * Shared option lists for PAT pickup, reception and shipment dropdowns.
 * Update here to reflect across all three tabs.
 */

export const TRANSPORTADORAS = [
  { label: "NACEX", value: "NACEX" },
  { label: "Outro", value: "Outro" },
];

export const MEIOS_TRANSPORTE = [
  { label: "NACEX", value: "NACEX" },
  { label: "Outro", value: "Outro" },
];
